function search_box_init(selector)
{
    $(selector).select2({
        placeholder: "brak",
        initSelection : function (element, callback) {
            callback({id: element.val(), text: element.data('label')});
        },
        minimumInputLength: 3,
        allowClear: true,
        escapeMarkup: function (m) { return m; },
        ajax: {
            url: laroute.route('public::propositions::ajax::search_track', {guid: $('meta[name="list-guid"]').attr('content')}),
            dataType: 'json',
            quietMillis: 500,
            data: function (term, page) {
                return {
                    q: term,
                    p: page,
                };
            },
            results: function (data, page) {
                return data;
            }
        }
    });
}

if($('.track_search_box').length) {
    search_box_init(".track_search_box")
}